import { render } from "./course-curriculam.vue?vue&type=template&id=188bca3b"
import script from "./course-curriculam.vue?vue&type=script&lang=js"
export * from "./course-curriculam.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__